<template>
  <v-container fluid>
    <div>
      <v-layout row>
        <v-flex xs4>
          <v-text-field
            name="Search"
            label="Search"
            v-model="SearchText"
            append-icon="search"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </div>

    <v-data-table
      :headers="headers"
      :items="filteredRows"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <v-progress-linear
        slot="progress"
        color="blue"
        indeterminate
      ></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.item.orderID }}</td>
        <td v-if="isAdmin">{{ props.item.dealerDetails.ubDealerID }}</td>
        <td v-if="isAdmin">{{ props.item.dealerDetails.dealerFullName }}</td>
        <td class="text-md-right">{{ props.item.createdDate | formatDate }}</td>
        <td class="text-md-right">{{ props.item.orderString }}</td>
        <td class="text-md-right">
          {{ props.item.orderStatus | orderStatus }}
        </td>
        <td class="text-md-right">{{ props.item.ticket }}</td>
      </template>
    </v-data-table>
    <v-btn color="primary" @click="sendingDialog = true">Send Report</v-btn>

    <v-dialog v-model="sendingDialog" hide-overlay persistent width="300">
      <v-card :color="sendDialogColor" dark>
        <v-card-text>
          {{ this.sendingDialogText }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapMultiRowFields } from "vuex-map-fields";
import { mapActions, createNamespacedHelpers } from "vuex";
const {
  mapActions: mapOrderActions,
  mapMutations: mapOrderMutations,
  mapGetters: mapOrderGetters,
} = createNamespacedHelpers(`orders`);
export default {
  name: "order-inprogress",
  components: {},

  data() {
    return {
      valid: true,
      SearchText: null,
      items: [],
      sendingDialog: false,
      sendDialogColor: "primary",
      sendingDialogText: "Please wait",
      totalItems: 0,
      pagination: {
        page: 1,
        rowsPerPage: 20,
        totalItems: 0,
        descending: true,
      },
      loading: false,
      headers: [
        {
          text: "Order ID",
          align: "left",
          sortable: true,
          value: "orderID",
        },
        {
          text: "Created Date",
          align: "right",
          sortable: true,
          value: "createdDate",
        },
        {
          text: "Customer / Company",
          align: "right",
          sortable: false,
          //value: 'customerDetails.surname'
        },
        {
          text: "Status",
          align: "right",
          sortable: true,
          value: "true",
        },
        {
          text: "Ticket#",
          align: "right",
          sortable: false,
          value: "true",
        },
      ],
    };
  },
  methods: {
    ...mapOrderActions(["listInProgressOrders", "sendInProgressOrders"]),
    isValid: function(item) {
      let vm = this;
      if (vm.SearchText === null) return true;
      const filters = vm.headers.filter((x) => x.sortable).map((x) => x.value);

      for (var i = 0; i < filters.length; i++) {
        if (typeof item[filters[i]] !== null) {
          let reviewedString = "";
          if (Number.isInteger(item[filters[i]]))
            reviewedString = item[filters[i]].toString().toUpperCase();
          if (reviewedString.includes(vm.SearchText.toUpperCase())) return true;
        }
      }
    },
    sendInProgressReports: function() {
      let vm = this;
      var parameters = {
        receipt: "dealer@vonex.com.au",
        sendingTime: new Date().toUTCString(),
      };
      vm.sendInProgressOrders(parameters.receipt, parameters.sendingTime)
        .then(() => {
          this.sendDialogColor = "green";
          this.sendingDialogText = "Report emailed";
          setTimeout(() => (this.sendingDialog = false), 1000);
          this.sendDialogColor = "primary";
          this.sendingDialogText = "Please wait";
        })
        .catch(() => {
          this.sendDialogColor = "red";
          this.sendingDialogText = "Report failed to send";
          setTimeout(() => (this.sendingDialog = false), 1000);
          this.sendDialogColor = "primary";
          this.sendingDialogText = "Please wait";
        });
    },
  },
  computed: {
    ...mapOrderGetters(["isAdmin"]),
    filteredRows: function() {
      let vm = this;
      return vm.items.filter(this.isValid);
    },
  },
  mounted() {
    let vm = this;
    // this.$validator.localize("en", this.dictionary);
    this.listInProgressOrders()
      .then((data) => {
        vm.items = data;
        vm.total = data.Count();
        vm.loading = false;
      })
      .catch(() => {});
  },
  watch: {
    sendingDialog(val) {
      if (!val) return;
      this.sendingDialog = true;
      this.sendingDialogText = "Please wait";
      this.sendInProgressReports();
    },
  },
};
</script>
